import $ from 'jquery'

/* @ngInject */
const myHomeMenu = (
  $timeout,
  $$account
) => {
  return {
    restrict: 'E',
    scope: {
      myMenus: '=',
    },
    template: require('./myHomeMenu.html'),

    /* @ngInject */
    controller: ($scope, userService) => {
      $timeout(() => {
        $('.sidenav').sideNav()
      })

      $scope.logout = () => {
        userService.logout()
        $$account.ask.askLogin()
      }

      $scope.login = () => {
        $$account.ask.askLogin()
      }
    },
    link: (scope, element, attrs, ctrl) => {

    },
  }
}

export default myHomeMenu



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/menus/myHomeMenu.js